import { getGDPRCookie } from "./getGDPRCookie";

export function getCountryCode() {
  const gdprCookie = getGDPRCookie();
  return gdprCookie?.country;
}
